<template>
	<div class="cog-name" :class="{'cog-name--narrow': isNarrow}">
		<div v-if="readonly" class="cog-input is-read-only">{{ name.toString(format) }}</div>
		<c-row v-else>
			<c-wrap :when="includeProperty('Prefix') && includeProperty('MiddleInitial') && includeProperty('Suffix')" class="cog-name__group">
				<c-input
					v-if="includeProperty('Prefix')"
					v-model="name.Prefix"
					:placeholder="$resource('name-prefix')"
					:title="$resource('name-prefix')"
					:label="$resource('name-prefix')"
					:readonly="readonly"
					class="cog-name__prefix cog-input--small"
					autocomplete="honorific-prefix"
				/>
				<c-input
					v-model="name.First"
					:placeholder="$resource('name-first')"
					:title="$resource('name-first')"
					:label="$resource('name-first')"
					:readonly="readonly"
					class="cog-name__first cog-input--long"
					autocomplete="given-name"
				/>
				<c-input
					v-if="includeProperty('MiddleInitial')"
					v-model="name.MiddleInitial"
					:placeholder="$resource('name-middleinitial')"
					:title="$resource('name-middleinitial')"
					:label="$resource('name-middleinitial')"
					:readonly="readonly"
					:maxlength="1"
					class="cog-name__middle-initial cog-input--tiny"
					autocomplete="additional-name"
				/>
				<c-input
					v-if="includeProperty('Middle')"
					v-model="name.Middle"
					:placeholder="$resource('name-middle')"
					:title="$resource('name-middle')"
					:label="$resource('name-middle')"
					:readonly="readonly"
					class="cog-name__middle cog-input--long"
					autocomplete="additional-name"
				/>
			</c-wrap>
			<c-wrap :when="includeProperty('Last') && includeProperty('Suffix')" class="cog-name__group">
				<c-input
					v-model="name.Last"
					:placeholder="$resource('name-last')"
					:title="$resource('name-last')"
					:label="$resource('name-last')"
					:readonly="readonly"
					class="cog-name__last cog-input--long"
					autocomplete="family-name"
				/>
				<c-input
					v-if="includeProperty('Suffix')"
					v-model="name.Suffix"
					:placeholder="$resource('name-suffix')"
					:title="$resource('name-suffix')"
					:label="$resource('name-suffix')"
					:readonly="readonly"
					class="cog-name__suffix cog-input--small"
					autocomplete="honorific-suffix"
				/>
			</c-wrap>
		</c-row>
	</div>
</template>

<script>
	import CRow from './Row.vue';
	import CInput from './Input.vue';
	import { uiDebounce } from 'src/util/debounce';
	import CWrap from './wrap';

	export default {
		name: 'CName',
		components: {
			CInput,
			CRow,
			CWrap
		},
		inject: ['$resource'],
		props: {
			readonly: Boolean,
			name: {
				type: Object,
				default: () => ({
					Prefix: '',
					First: '',
					MiddleInitial: '',
					Middle: '',
					Last: '',
					Suffix: ''
				})
			},
			properties: { type: String, default: 'First, Last' },
			format: { type: String, default: '[First] [Last]' }
		},
		data() {
			return {
				width: null,
				isNarrow: false,
				debounceResize: uiDebounce(() => this.resize())
			};
		},
		computed: {
			nameProperties: function () {
				return this.properties.split(',').map(p => p.trim());
			}
		},
		mounted() {
			this.debounceResize();
			window.addEventListener('resize', this.debounceResize);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.debounceResize);
		},
		methods: {
			includeProperty: function (propName) {
				return this.nameProperties.indexOf(propName) >= 0;
			},
			resize() {
				const newWidth = this.$el.clientWidth;
				if (this.width !== newWidth)
					this.isNarrow = newWidth <= 320;
				this.width = newWidth;
			}
		}
	};
</script>

<style lang="scss">
#{$specificity-base} {

	.cog-name__group {
		display: flex;
		flex: 1 1 18em;
	}

	.cog-form:not([data-old-safari]) .cog-name__group {
		column-gap: $gutter-half;
	}

	.cog-name--narrow .cog-name__group {
		flex-wrap: wrap;
	}
}
</style>